import React, { useState, useEffect } from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { BackgroundDots } from "./components/BackgroundDots";
import { CategoryGrid } from "./components/CategoryGrid";
import { StatsSection } from "./components/StatsSection";
import { NewsletterSection } from "./components/NewsletterSection";
import { Footer } from "./components/Footer";
import { CategoryModal } from "./components/CategoryModal";
import { QuickToolModal } from "./components/QuickToolModal";
import { InstallAppModal } from "./components/InstallAppModal";
import { SeoHead } from "./components/SeoHead";

const ContactPage = React.lazy(() => import("./pages/ContactPage").then(m => ({ default: m.ContactPage })));
const BlogPage = React.lazy(() => import("./pages/BlogPage").then(m => ({ default: m.BlogPage })));
const BlogPostPage = React.lazy(() => import("./pages/BlogPostPage").then(m => ({ default: m.BlogPostPage })));
const BlogExtractPdfPage = React.lazy(() => import("./pages/BlogExtractPdfPage").then(m => ({ default: m.BlogExtractPdfPage })));
const BlogSplitPdfPage = React.lazy(() => import("./pages/BlogSplitPdfPage").then(m => ({ default: m.BlogSplitPdfPage })));
const BlogRotatePdfPage = React.lazy(() => import("./pages/BlogRotatePdfPage").then(m => ({ default: m.BlogRotatePdfPage })));
const BlogRemovePdfPagesPage = React.lazy(() => import("./pages/BlogRemovePdfPagesPage").then(m => ({ default: m.BlogRemovePdfPagesPage })));
const BlogReorderPdfPagesPage = React.lazy(() => import("./pages/BlogReorderPdfPagesPage").then(m => ({ default: m.BlogReorderPdfPagesPage })));
const BlogCropPdfPage = React.lazy(() => import("./pages/BlogCropPdfPage").then(m => ({ default: m.BlogCropPdfPage })));
const BlogDuplicateFinderPage = React.lazy(() => import("./pages/BlogDuplicateFinderPage").then(m => ({ default: m.BlogDuplicateFinderPage })));
const BlogBlankPageRemoverPage = React.lazy(() => import("./pages/BlogBlankPageRemoverPage").then(m => ({ default: m.BlogBlankPageRemoverPage })));
const BlogPageNumberAdderPage = React.lazy(() => import("./pages/BlogPageNumberAdderPage").then(m => ({ default: m.BlogPageNumberAdderPage })));
const BlogPdfToImagesPage = React.lazy(() => import("./pages/BlogPdfToImagesPage").then(m => ({ default: m.BlogPdfToImagesPage })));
const BlogImagesToPdfPage = React.lazy(() => import("./pages/BlogImagesToPdfPage").then(m => ({ default: m.BlogImagesToPdfPage })));
const BlogPdfGrayscalePage = React.lazy(() => import("./pages/BlogPdfGrayscalePage").then(m => ({ default: m.BlogPdfGrayscalePage })));
const BlogPdfColorInverterPage = React.lazy(() => import("./pages/BlogPdfColorInverterPage").then(m => ({ default: m.BlogPdfColorInverterPage })));
const BlogPdfWatermarkPage = React.lazy(() => import("./pages/BlogPdfWatermarkPage").then(m => ({ default: m.BlogPdfWatermarkPage })));
const BlogPdfBookmarkViewerPage = React.lazy(() => import("./pages/BlogPdfBookmarkViewerPage").then(m => ({ default: m.BlogPdfBookmarkViewerPage })));
const BlogPdfBookmarkEditorPage = React.lazy(() => import("./pages/BlogPdfBookmarkEditorPage").then(m => ({ default: m.BlogPdfBookmarkEditorPage })));
const BlogPdfSignPage = React.lazy(() => import("./pages/BlogPdfSignPage").then(m => ({ default: m.BlogPdfSignPage })));
const BlogPdfAnnotationRemoverPage = React.lazy(() => import("./pages/BlogPdfAnnotationRemoverPage").then(m => ({ default: m.BlogPdfAnnotationRemoverPage })));
const BlogPdfMarginViewerPage = React.lazy(() => import("./pages/BlogPdfMarginViewerPage").then(m => ({ default: m.BlogPdfMarginViewerPage })));
const AboutPage = React.lazy(() => import("./pages/AboutPage").then(m => ({ default: m.AboutPage })));
const PrivacyPolicyPage = React.lazy(() => import("./pages/PrivacyPolicyPage").then(m => ({ default: m.PrivacyPolicyPage })));
const TermsOfServicePage = React.lazy(() => import("./pages/TermsOfServicePage").then(m => ({ default: m.TermsOfServicePage })));
const CategoriesPage = React.lazy(() => import("./pages/CategoriesPage").then(m => ({ default: m.CategoriesPage })));
const AllToolsPage = React.lazy(() => import("./pages/AllToolsPage").then(m => ({ default: m.AllToolsPage })));
const PdfToolsPage = React.lazy(() => import("./pages/PdfToolsPage").then(m => ({ default: m.PdfToolsPage })));
const PdfAnnotationRemoverPage = React.lazy(() => import("./pages/PdfAnnotationRemoverPage").then(m => ({ default: m.PdfAnnotationRemoverPage })));
const PdfMarginViewerPage = React.lazy(() => import("./pages/PdfMarginViewerPage").then(m => ({ default: m.PdfMarginViewerPage })));
const PdfMergePage = React.lazy(() => import("./pages/PdfMergePage").then(m => ({ default: m.PdfMergePage })));
const PdfSplitPage = React.lazy(() => import("./pages/PdfSplitPage").then(m => ({ default: m.PdfSplitPage })));
const PdfExtractPage = React.lazy(() => import("./pages/PdfExtractPage").then(m => ({ default: m.PdfExtractPage })));
const PdfToImagesPage = React.lazy(() => import("./pages/PdfToImagesPage").then(m => ({ default: m.PdfToImagesPage })));
const ImagesToPdfPage = React.lazy(() => import("./pages/ImagesToPdfPage").then(m => ({ default: m.ImagesToPdfPage })));
const PdfPageNumberAdderPage = React.lazy(() => import("./pages/PdfPageNumberAdderPage").then(m => ({ default: m.PdfPageNumberAdderPage })));
const PdfCropPage = React.lazy(() => import("./pages/PdfCropPage").then(m => ({ default: m.PdfCropPage })));
const PdfRemovePage = React.lazy(() => import("./pages/PdfRemovePage").then(m => ({ default: m.PdfRemovePage })));
const PdfDuplicateFinderPage = React.lazy(() => import("./pages/PdfDuplicateFinderPage").then(m => ({ default: m.PdfDuplicateFinderPage })));
const PdfBlankPageRemoverPage = React.lazy(() => import("./pages/PdfBlankPageRemoverPage").then(m => ({ default: m.PdfBlankPageRemoverPage })));
const PdfColorInverterPage = React.lazy(() => import("./pages/PdfColorInverterPage").then(m => ({ default: m.PdfColorInverterPage })));
const PdfGrayscaleConverterPage = React.lazy(() => import("./pages/PdfGrayscaleConverterPage").then(m => ({ default: m.PdfGrayscaleConverterPage })));
const PdfReorderPage = React.lazy(() => import("./pages/PdfReorderPage").then(m => ({ default: m.PdfReorderPage })));
const PdfRotatePage = React.lazy(() => import("./pages/PdfRotatePage").then(m => ({ default: m.PdfRotatePage })));
const PdfWatermarkPage = React.lazy(() => import("./pages/PdfWatermarkPage"));
const PdfBookmarkViewerPage = React.lazy(() => import("./pages/PdfBookmarkViewerPage").then(m => ({ default: m.PdfBookmarkViewerPage })));
const PdfBookmarkEditorPage = React.lazy(() => import("./pages/PdfBookmarkEditorPage").then(m => ({ default: m.PdfBookmarkEditorPage })));
const PdfSignaturePlaceholderPage = React.lazy(() => import("./pages/PdfSignaturePlaceholderPage").then(m => ({ default: m.PdfSignaturePlaceholderPage })));
const ImageToolsPage = React.lazy(() => import("./pages/ImageToolsPage").then(m => ({ default: m.ImageToolsPage })));
const TextToolsPage = React.lazy(() => import("./pages/TextToolsPage").then(m => ({ default: m.TextToolsPage })));
const DeveloperToolsPage = React.lazy(() => import("./pages/DeveloperToolsPage").then(m => ({ default: m.DeveloperToolsPage })));
const ColorToolsPage = React.lazy(() => import("./pages/ColorToolsPage").then(m => ({ default: m.ColorToolsPage })));
const SecurityToolsPage = React.lazy(() => import("./pages/SecurityToolsPage").then(m => ({ default: m.SecurityToolsPage })));
const SocialToolsPage = React.lazy(() => import("./pages/SocialToolsPage").then(m => ({ default: m.SocialToolsPage })));
const CalculatorToolsPage = React.lazy(() => import("./pages/CalculatorToolsPage").then(m => ({ default: m.CalculatorToolsPage })));
const FileToolsPage = React.lazy(() => import("./pages/FileToolsPage").then(m => ({ default: m.FileToolsPage })));
const MiscToolsPage = React.lazy(() => import("./pages/MiscToolsPage").then(m => ({ default: m.MiscToolsPage })));
const DataToolsPage = React.lazy(() => import("./pages/DataToolsPage").then(m => ({ default: m.DataToolsPage })));
const ProductivityToolsPage = React.lazy(() => import("./pages/ProductivityToolsPage").then(m => ({ default: m.ProductivityToolsPage })));
const UnitConversionToolsPage = React.lazy(() => import("./pages/UnitConversionToolsPage").then(m => ({ default: m.UnitConversionToolsPage })));
const TimeDateToolsPage = React.lazy(() => import("./pages/TimeDateToolsPage").then(m => ({ default: m.TimeDateToolsPage })));
const FinanceToolsPage = React.lazy(() => import("./pages/FinanceToolsPage").then(m => ({ default: m.FinanceToolsPage })));

import { PDF_TOOLS_DATA } from "./data/pdfToolsData";
import { IMAGE_TOOLS_DATA } from "./data/imageToolsData";
import { TEXT_TOOLS_DATA } from "./data/textToolsData";
import { DEV_TOOLS_DATA } from "./data/devToolsData";
import { COLOR_TOOLS_DATA } from "./data/colorToolsData";
import { SECURITY_TOOLS_DATA } from "./data/securityToolsData";
import { SOCIAL_TOOLS_DATA } from "./data/socialToolsData";
import { CALCULATOR_TOOLS_DATA } from "./data/calculatorToolsData";
import { FILE_TOOLS_DATA } from "./data/fileToolsData";
import { MISC_TOOLS_DATA } from "./data/miscToolsData";
import { DATA_TOOLS_DATA } from "./data/dataToolsData";
import { PRODUCTIVITY_TOOLS_DATA } from "./data/productivityToolsData";
import { UNIT_CONVERSION_TOOLS_DATA } from "./data/unitConversionToolsData";
import { TIME_DATE_TOOLS_DATA } from "./data/timeDateToolsData";
import { FINANCE_TOOLS_DATA } from "./data/financeToolsData";
import { CATEGORIES_DATA, STATS_DATA } from "./data/categories";
import { ALL_TOOLS_DATA } from "./data/allToolsData";
import { ThemeMode, CategoryItem, ToolItem } from "./types";
import { Search, Star, ArrowRight, Lock } from "lucide-react";
import { useI18n } from "./i18n/I18nContext";
import { getNormalizedPath } from "./i18n/languages";

export default function App() {
  const { lang, getLangUrl, normalizedRoute } = useI18n();

  // Helper to map normalized route path to activeNav string identifier
  const getNavFromRoute = (route: string): string => {
    const clean = route.replace(/^\/+|\/+$/g, "").toLowerCase();
    if (!clean || clean === "home") return "home";
    if (clean === "tools" || clean === "all-tools") return "all-tools";
    if (clean === "categories") return "categories";
    if (clean === "blog") return "blog";
    if (clean === "about") return "about";
    if (clean === "contact") return "contact";
    if (clean === "privacy-policy" || clean === "privacy") return "privacy-policy";
    if (clean === "terms-of-service" || clean === "terms") return "terms-of-service";

    // Category routing
    if (clean.startsWith("category/") || clean.startsWith("categories/")) {
      const catId = clean.replace(/^(category|categories)\//, "");
      if (catId === "pdf-tools" || catId === "pdf") return "pdf-tools";
      if (catId === "image-tools" || catId === "image" || catId === "images") return "image-tools";
      if (catId === "text-tools" || catId === "text") return "text-tools";
      if (catId === "developer-tools" || catId === "dev-tools" || catId === "dev") return "developer-tools";
      if (catId === "color-tools" || catId === "colour-tools" || catId === "color") return "color-tools";
      if (catId === "security-tools" || catId === "security") return "security-tools";
      if (catId === "social-tools" || catId === "social-media-tools" || catId === "social") return "social-tools";
      if (catId === "calculator-tools" || catId === "calculators" || catId === "calculator") return "calculator-tools";
      if (catId === "file-tools" || catId === "files" || catId === "file") return "file-tools";
      if (catId === "misc-tools" || catId === "miscellaneous" || catId === "misc") return "misc-tools";
      if (catId === "data-tools" || catId === "data" || catId === "data-converters") return "data-tools";
      if (catId === "productivity-tools" || catId === "productivity") return "productivity-tools";
      if (catId === "unit-conversion" || catId === "unit-tools" || catId === "converters" || catId === "unit-converter") return "unit-conversion";
      if (catId === "time-date-tools" || catId === "time-tools" || catId === "time-date") return "time-date-tools";
      if (catId === "finance-tools" || catId === "finance" || catId === "financial-calculators") return "finance-tools";
      return "categories";
    }

    // Direct Category IDs
    if (clean === "pdf-tools" || clean === "pdf") return "pdf-tools";
    if (clean === "image-tools" || clean === "image" || clean === "images") return "image-tools";
    if (clean === "text-tools" || clean === "text") return "text-tools";
    if (clean === "developer-tools" || clean === "dev-tools" || clean === "dev") return "developer-tools";
    if (clean === "color-tools" || clean === "colour-tools" || clean === "color") return "color-tools";
    if (clean === "security-tools" || clean === "security") return "security-tools";
    if (clean === "social-tools" || clean === "social-media-tools" || clean === "social") return "social-tools";
    if (clean === "calculator-tools" || clean === "calculators" || clean === "calculator") return "calculator-tools";
    if (clean === "file-tools" || clean === "files" || clean === "file") return "file-tools";
    if (clean === "misc-tools" || clean === "miscellaneous" || clean === "misc") return "misc-tools";
    if (clean === "data-tools" || clean === "data" || clean === "data-converters") return "data-tools";
    if (clean === "productivity-tools" || clean === "productivity") return "productivity-tools";
    if (clean === "unit-conversion" || clean === "unit-tools" || clean === "converters" || clean === "unit-converter") return "unit-conversion";
    if (clean === "time-date-tools" || clean === "time-tools" || clean === "time-date") return "time-date-tools";
    if (clean === "finance-tools" || clean === "finance" || clean === "financial-calculators") return "finance-tools";

    // Dedicated PDF Tools
    if (clean === "pdf-merge" || clean === "pdf-merger" || clean === "merge-pdf") return "pdf-merge";
    if (clean === "pdf-rotator" || clean === "pdf-rotate" || clean === "rotate-pdf") return "pdf-rotator";
    if (clean === "pdf-split" || clean === "pdf-splitter" || clean === "split-pdf") return "pdf-split";
    if (clean === "pdf-extractor" || clean === "pdf-extract" || clean === "extract-pdf") return "pdf-extractor";
    if (clean === "pdf-page-number-adder" || clean === "add-page-numbers-pdf") return "pdf-page-number-adder";
    if (clean === "pdf-to-images" || clean === "pdf-to-image" || clean === "pdf-to-png" || clean === "pdf-to-jpg" || clean === "pdf-jpg") return "pdf-to-images";
    if (clean === "images-to-pdf" || clean === "image-to-pdf" || clean === "jpg-to-pdf" || clean === "png-to-pdf") return "images-to-pdf";
    if (clean === "pdf-crop" || clean === "crop-pdf") return "pdf-crop";
    if (clean === "pdf-reorder-pages" || clean === "pdf-reorder" || clean === "reorder-pdf" || clean === "reorder-pages") return "pdf-reorder-pages";
    if (
      clean === "pdf-duplicate-page-finder" ||
      clean === "pdf-duplicate-finder" ||
      clean === "pdf-duplicate" ||
      clean === "duplicate-pdf" ||
      clean === "duplicate-pages" ||
      clean === "duplicate-finder" ||
      clean === "duplicate-page-finder"
    ) return "pdf-duplicate-page-finder";
    if (clean === "pdf-page-remover" || clean === "pdf-remove" || clean === "remove-pdf" || clean === "remove-pages") return "pdf-page-remover";
    if (clean === "pdf-blank-page-remover" || clean === "pdf-blank-remover" || clean === "pdf-remove-blank-pages" || clean === "remove-blank-pages" || clean === "blank-page-remover") return "pdf-blank-page-remover";
    if (clean === "pdf-color-inverter" || clean === "color-inverter" || clean === "invert-pdf-colors" || clean === "pdf-color-invert") return "pdf-color-inverter";
    if (clean === "pdf-grayscale-converter" || clean === "pdf-grayscale" || clean === "convert-pdf-to-grayscale" || clean === "pdf-to-grayscale" || clean === "grayscale-pdf") return "pdf-grayscale-converter";
    if (clean === "pdf-watermark" || clean === "watermark-pdf" || clean === "pdf-watermark-adder" || clean === "watermark") return "pdf-watermark";
    if (clean === "pdf-bookmark-editor" || clean === "pdf-bookmark" || clean === "edit-pdf-bookmarks" || clean === "edit-bookmarks") return "pdf-bookmark-editor";
    if (clean === "pdf-bookmark-viewer" || clean === "pdf-bookmarks" || clean === "pdf-outline-viewer" || clean === "view-pdf-bookmarks") return "pdf-bookmark-viewer";
    if (clean === "pdf-annotation-remover" || clean === "annotation-remover" || clean === "remove-pdf-annotations" || clean === "pdf-annotations-remover") return "pdf-annotation-remover";
    if (clean === "pdf-margin-viewer" || clean === "pdf-margins" || clean === "pdf-margin" || clean === "pdf-margin-inspector" || clean === "margin-viewer") return "pdf-margin-viewer";
    if (clean === "pdf-signature-placeholder" || clean === "pdf-signature" || clean === "pdf-signatures" || clean === "signature-placeholder" || clean === "add-pdf-signature-placeholder") return "pdf-signature-placeholder";

    // Dedicated Blog Posts
    if (
      clean === "merge-pdf-files-online" ||
      clean === "blog/merge-pdf-files-online" ||
      clean === "blog/how-to-merge-pdf-files" ||
      clean === "how-to-merge-pdf-files"
    ) {
      return "blog/how-to-merge-pdf-files";
    }
    
    if (
      clean === "blog/how-to-extract-pdf-pages" ||
      clean === "how-to-extract-pdf-pages"
    ) {
      return "blog/how-to-extract-pdf-pages";
    }

    if (
      clean === "blog/how-to-split-pdf-files" ||
      clean === "how-to-split-pdf-files" ||
      clean === "blog/how-to-split-pdf-into-separate-files" ||
      clean === "how-to-split-pdf-into-separate-files" ||
      clean === "split-pdf-into-separate-files" ||
      clean === "blog/split-pdf-into-separate-files"
    ) {
      return "blog/how-to-split-pdf-files";
    }

    if (
      clean === "blog/how-to-rotate-pdf-pages" ||
      clean === "how-to-rotate-pdf-pages" ||
      clean === "blog/how-to-rotate-pdf-online" ||
      clean === "how-to-rotate-pdf-online" ||
      clean === "rotate-pdf-online-free" ||
      clean === "blog/rotate-pdf-online-free" ||
      clean === "how-to-rotate-pdf" ||
      clean === "blog/how-to-rotate-pdf"
    ) {
      return "blog/how-to-rotate-pdf-pages";
    }

    if (
      clean === "blog/remove-pages-from-pdf" ||
      clean === "remove-pages-from-pdf" ||
      clean === "blog/how-to-remove-pages-from-pdf" ||
      clean === "how-to-remove-pages-from-pdf" ||
      clean === "blog/pdf-page-remover" ||
      clean === "pdf-page-remover-guide"
    ) {
      return "blog/remove-pages-from-pdf";
    }

    if (
      clean === "blog/reorder-pdf-pages" ||
      clean === "reorder-pdf-pages" ||
      clean === "blog/how-to-reorder-pdf-pages" ||
      clean === "how-to-reorder-pdf-pages" ||
      clean === "how-to-reorder-pdf" ||
      clean === "blog/how-to-reorder-pdf" ||
      clean === "blog/pdf-reorder" ||
      clean === "pdf-reorder-guide"
    ) {
      return "blog/reorder-pdf-pages";
    }

    if (
      clean === "blog/crop-pdf" ||
      clean === "crop-pdf" ||
      clean === "blog/how-to-crop-pdf" ||
      clean === "how-to-crop-pdf" ||
      clean === "how-to-crop-pdf-pages" ||
      clean === "blog/how-to-crop-pdf-pages" ||
      clean === "blog/pdf-crop" ||
      clean === "pdf-crop-guide"
    ) {
      return "blog/how-to-crop-pdf";
    }

    if (
      clean === "blog/pdf-duplicate-finder" ||
      clean === "pdf-duplicate-finder-guide" ||
      clean === "blog/how-to-find-duplicate-pages-in-pdf" ||
      clean === "how-to-find-duplicate-pages-in-pdf" ||
      clean === "how-to-find-duplicate-pages" ||
      clean === "blog/how-to-find-duplicate-pages" ||
      clean === "how-to-remove-duplicate-pages-from-pdf" ||
      clean === "blog/how-to-remove-duplicate-pages-from-pdf" ||
      clean === "blog/duplicate-pdf-finder" ||
      clean === "duplicate-pdf-finder"
    ) {
      return "blog/how-to-find-duplicate-pages-in-pdf";
    }

    if (
      clean === "blog/how-to-remove-blank-pages-from-pdf" ||
      clean === "how-to-remove-blank-pages-from-pdf" ||
      clean === "blog/how-to-remove-blank-pages" ||
      clean === "how-to-remove-blank-pages" ||
      clean === "blog/remove-blank-pages-from-pdf" ||
      clean === "remove-blank-pages-from-pdf" ||
      clean === "blog/remove-blank-pages" ||
      clean === "remove-blank-pages" ||
      clean === "blog/pdf-blank-page-remover" ||
      clean === "pdf-blank-page-remover-guide" ||
      clean === "blog/blank-page-remover"
    ) {
      return "blog/how-to-remove-blank-pages-from-pdf";
    }

    if (
      clean === "blog/how-to-add-page-numbers-to-pdf" ||
      clean === "how-to-add-page-numbers-to-pdf" ||
      clean === "blog/how-to-add-page-numbers" ||
      clean === "how-to-add-page-numbers" ||
      clean === "blog/add-page-numbers-to-pdf" ||
      clean === "add-page-numbers-to-pdf" ||
      clean === "blog/add-page-numbers" ||
      clean === "add-page-numbers" ||
      clean === "blog/pdf-number-adder" ||
      clean === "blog/pdf-page-number-adder" ||
      clean === "pdf-page-number-adder-guide" ||
      clean === "pdf-number-adder-guide"
    ) {
      return "blog/how-to-add-page-numbers-to-pdf";
    }

    if (
      clean === "blog/how-to-convert-pdf-to-images" ||
      clean === "how-to-convert-pdf-to-images" ||
      clean === "blog/how-to-convert-pdf-to-image" ||
      clean === "how-to-convert-pdf-to-image" ||
      clean === "blog/pdf-to-images" ||
      clean === "blog/pdf-to-image" ||
      clean === "pdf-to-images-guide" ||
      clean === "pdf-to-image-guide" ||
      clean === "blog/convert-pdf-to-images" ||
      clean === "convert-pdf-to-images"
    ) {
      return "blog/how-to-convert-pdf-to-images";
    }

    if (
      clean === "blog/how-to-convert-images-to-pdf" ||
      clean === "how-to-convert-images-to-pdf" ||
      clean === "blog/how-to-convert-image-to-pdf" ||
      clean === "how-to-convert-image-to-pdf" ||
      clean === "blog/images-to-pdf" ||
      clean === "blog/image-to-pdf" ||
      clean === "images-to-pdf-guide" ||
      clean === "image-to-pdf-guide" ||
      clean === "blog/convert-images-to-pdf" ||
      clean === "convert-images-to-pdf" ||
      clean === "how-to-convert-images-into-pdf" ||
      clean === "blog/how-to-convert-images-into-pdf"
    ) {
      return "blog/how-to-convert-images-to-pdf";
    }

    if (
      clean === "blog/how-to-convert-pdf-to-grayscale" ||
      clean === "how-to-convert-pdf-to-grayscale" ||
      clean === "blog/how-to-convert-pdf-to-black-and-white" ||
      clean === "how-to-convert-pdf-to-black-and-white" ||
      clean === "blog/pdf-grayscale" ||
      clean === "pdf-grayscale-guide" ||
      clean === "blog/pdf-to-grayscale" ||
      clean === "pdf-to-grayscale-guide" ||
      clean === "blog/convert-pdf-to-grayscale" ||
      clean === "convert-pdf-to-grayscale" ||
      clean === "blog/pdf-black-and-white" ||
      clean === "pdf-black-and-white-guide"
    ) {
      return "blog/how-to-convert-pdf-to-grayscale";
    }

    if (
      clean === "blog/how-to-invert-pdf-colors" ||
      clean === "how-to-invert-pdf-colors" ||
      clean === "blog/how-to-invert-colors-in-pdf" ||
      clean === "how-to-invert-colors-in-pdf" ||
      clean === "blog/pdf-color-inverter" ||
      clean === "pdf-color-inverter-guide" ||
      clean === "blog/pdf-dark-mode" ||
      clean === "pdf-dark-mode-guide" ||
      clean === "blog/invert-pdf-colors" ||
      clean === "invert-pdf-colors" ||
      clean === "blog/how-to-turn-pdf-into-dark-mode" ||
      clean === "how-to-turn-pdf-into-dark-mode"
    ) {
      return "blog/how-to-invert-pdf-colors";
    }

    if (
      clean === "blog/how-to-add-watermark-to-pdf" ||
      clean === "how-to-add-watermark-to-pdf" ||
      clean === "blog/how-to-watermark-pdf" ||
      clean === "how-to-watermark-pdf" ||
      clean === "blog/pdf-watermark" ||
      clean === "pdf-watermark-guide" ||
      clean === "blog/add-watermark-to-pdf" ||
      clean === "add-watermark-to-pdf" ||
      clean === "blog/watermark-pdf" ||
      clean === "watermark-pdf"
    ) {
      return "blog/how-to-add-watermark-to-pdf";
    }

    if (
      clean === "blog/how-to-view-pdf-bookmarks" ||
      clean === "how-to-view-pdf-bookmarks" ||
      clean === "blog/how-to-inspect-pdf-bookmarks" ||
      clean === "how-to-inspect-pdf-bookmarks" ||
      clean === "blog/pdf-bookmark-viewer" ||
      clean === "pdf-bookmark-viewer-guide" ||
      clean === "blog/pdf-bookmarks" ||
      clean === "blog/view-pdf-bookmarks" ||
      clean === "view-pdf-bookmarks" ||
      clean === "blog/pdf-bookmark-guide"
    ) {
      return "blog/how-to-view-pdf-bookmarks";
    }

    if (
      clean === "blog/how-to-edit-pdf-bookmarks" ||
      clean === "how-to-edit-pdf-bookmarks" ||
      clean === "blog/pdf-bookmark-editor" ||
      clean === "pdf-bookmark-editor-guide" ||
      clean === "blog/edit-pdf-bookmarks" ||
      clean === "edit-pdf-bookmarks"
    ) {
      return "blog/how-to-edit-pdf-bookmarks";
    }

    if (
      clean === "blog/how-to-sign-pdf" ||
      clean === "how-to-sign-pdf" ||
      clean === "blog/pdf-sign" ||
      clean === "pdf-sign-guide" ||
      clean === "blog/sign-pdf" ||
      clean === "sign-pdf"
    ) {
      return "blog/how-to-sign-pdf";
    }

    if (
      clean === "blog/how-to-remove-pdf-annotations" ||
      clean === "how-to-remove-pdf-annotations" ||
      clean === "blog/how-to-remove-annotations-from-pdf" ||
      clean === "how-to-remove-annotations-from-pdf" ||
      clean === "blog/pdf-annotation-remover" ||
      clean === "pdf-annotation-remover-guide" ||
      clean === "blog/remove-pdf-annotations" ||
      clean === "remove-pdf-annotations"
    ) {
      return "blog/how-to-remove-pdf-annotations";
    }

    if (
      clean === "blog/how-to-view-pdf-margins" ||
      clean === "how-to-view-pdf-margins" ||
      clean === "blog/how-to-measure-pdf-margins" ||
      clean === "how-to-measure-pdf-margins" ||
      clean === "blog/pdf-margin-viewer" ||
      clean === "pdf-margin-viewer-guide" ||
      clean === "blog/view-pdf-margins" ||
      clean === "view-pdf-margins" ||
      clean === "blog/measure-pdf-margins" ||
      clean === "measure-pdf-margins"
    ) {
      return "blog/how-to-view-pdf-margins";
    }

    // Blog subroutes
    if ((clean.startsWith("blog/") && clean !== "blog") || clean.startsWith("how-to-") || clean === "getting-started") {
      return "blog";
    }

    if (
      clean === "pdf-number-adder" ||
      clean === "pdf-page-number" ||
      clean === "add-numbers-to-pdf" ||
      clean === "add-page-numbers"
    ) {
      return "pdf-page-number-adder";
    }

    // Tool URL Prefix
    if (clean.startsWith("tool/")) {
      const tid = clean.replace("tool/", "");
      return getNavFromRoute(tid);
    }

    // Check if the clean path matches any tool ID in ALL_TOOLS_DATA
    const foundTool = ALL_TOOLS_DATA.find((t) => t.id === clean);
    if (foundTool) {
      return clean;
    }

    return clean;
  };

  // Helper to map activeNav string identifier to normalized route path
  const getRouteFromNav = (nav: string): string => {
    if (nav === "home" || nav === "") return "/";
    if (nav === "all-tools" || nav === "tools") return "/tools";
    return `/${nav}`;
  };

  // Theme state: defaults to dark theme
  const [theme, setTheme] = useState<ThemeMode>(() => {
    const saved = localStorage.getItem("dualis_theme");
    return saved === "light" || saved === "dark" ? saved : "dark";
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [activeNav, setActiveNav] = useState<string>(() => {
    if (typeof window !== "undefined") {
      const currentPath = window.location.pathname;
      return getNavFromRoute(getNormalizedPath(currentPath));
    }
    return "home";
  });

  const [selectedCategory, setSelectedCategory] = useState<CategoryItem | null>(
    null,
  );
  const [activeQuickTool, setActiveQuickTool] = useState<ToolItem | null>(() => {
    if (typeof window !== "undefined") {
      const currentPath = window.location.pathname;
      const cleanPath = getNormalizedPath(currentPath).replace(/^\/+|\/+$/g, "").toLowerCase();
      const toolId = cleanPath.startsWith("tool/") ? cleanPath.replace("tool/", "") : cleanPath;
      const dedicatedPdfTools = [
        "pdf-merge", "pdf-rotator", "pdf-split", "pdf-extractor", "pdf-to-images", 
        "images-to-pdf", "pdf-page-number-adder", "pdf-crop", "pdf-reorder-pages", 
        "pdf-duplicate-page-finder", "pdf-page-remover", "pdf-blank-page-remover", 
        "pdf-color-inverter", "pdf-grayscale-converter", "pdf-watermark", 
        "pdf-bookmark-editor", "pdf-bookmark-viewer", "pdf-signature-placeholder",
        "pdf-annotation-remover", "pdf-margin-viewer"
      ];
      if (!dedicatedPdfTools.includes(toolId) && toolId && toolId !== "home" && toolId !== "tools") {
        const found = ALL_TOOLS_DATA.find(t => t.id === toolId);
        if (found) return found;
      }
    }
    return null;
  });
  const [favoritesModalOpen, setFavoritesModalOpen] = useState(false);
  const [installAppModalOpen, setInstallAppModalOpen] = useState(false);

  // Sync activeNav and tool with normalized URL route on URL changes, back/forward, or direct navigation
  useEffect(() => {
    if (typeof window !== "undefined") {
      const cleanPath = normalizedRoute.replace(/^\/+|\/+$/g, "").toLowerCase();

      const dedicatedPdfTools = [
        "pdf-merge", "pdf-rotator", "pdf-split", "pdf-extractor", "pdf-to-images", 
        "images-to-pdf", "pdf-page-number-adder", "pdf-crop", "pdf-reorder-pages", 
        "pdf-duplicate-page-finder", "pdf-page-remover", "pdf-blank-page-remover", 
        "pdf-color-inverter", "pdf-grayscale-converter", "pdf-watermark", 
        "pdf-bookmark-editor", "pdf-bookmark-viewer", "pdf-signature-placeholder",
        "pdf-annotation-remover", "pdf-margin-viewer"
      ];

      const rawToolId = cleanPath.startsWith("tool/") ? cleanPath.replace("tool/", "") : cleanPath;
      const routeNav = getNavFromRoute(normalizedRoute);

      if (cleanPath.startsWith("tool/") || (!dedicatedPdfTools.includes(rawToolId) && ALL_TOOLS_DATA.some(t => t.id === rawToolId))) {
        const toolId = rawToolId;
        if (dedicatedPdfTools.includes(getNavFromRoute(toolId))) {
          const mappedNav = getNavFromRoute(toolId);
          if (mappedNav !== activeNav) {
            React.startTransition(() => {
              setActiveNav(mappedNav);
            });
          }
          if (activeQuickTool) setActiveQuickTool(null);
        } else {
          if (!activeQuickTool || activeQuickTool.id !== toolId) {
            handleLaunchToolById(toolId);
          }
        }
      } else {
        if (routeNav !== activeNav) {
          React.startTransition(() => {
            setActiveNav(routeNav);
          });
        }
        if (activeQuickTool) {
          setActiveQuickTool(null);
        }
      }
    }
  }, [normalizedRoute]);

  // Favorites stored in localStorage
  const [favorites, setFavorites] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem("dualis_favorites");
      return saved
        ? JSON.parse(saved)
        : ["password-generator", "compress-image", "json-formatter"];
    } catch {
      return ["password-generator", "compress-image", "json-formatter"];
    }
  });

  // Keep body class synced with theme
  useEffect(() => {
    localStorage.setItem("dualis_theme", theme);
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  // Persist favorites
  useEffect(() => {
    localStorage.setItem("dualis_favorites", JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (activeQuickTool) {
      const toolUrl = getLangUrl(`/tool/${activeQuickTool.id}`);
      if (window.location.pathname !== toolUrl) {
        window.history.pushState(
          { nav: activeNav, tool: activeQuickTool.id },
          "",
          toolUrl,
        );
      }
    } else {
      // Revert to current nav route
      const targetRoute = getRouteFromNav(activeNav);
      const fullLangUrl = getLangUrl(targetRoute);
      if (
        window.location.pathname !== fullLangUrl &&
        window.location.pathname.toLowerCase().includes("/tool/")
      ) {
        window.history.pushState({ nav: activeNav }, "", fullLangUrl);
      }
    }
  }, [activeQuickTool, activeNav, getLangUrl]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const toggleFavorite = (toolId: string) => {
    setFavorites((prev) =>
      prev.includes(toolId)
        ? prev.filter((id) => id !== toolId)
        : [...prev, toolId],
    );
  };

  const handleNavigate = (nav: string) => {
    const cleanNav = nav.replace(/^\/+|\/+$/g, "").toLowerCase();

    // Update browser URL subpath for international routing
    const targetRoute = getRouteFromNav(nav);
    const fullLangUrl = getLangUrl(targetRoute);
    if (
      typeof window !== "undefined" &&
      window.location.pathname !== fullLangUrl
    ) {
      window.history.pushState({ nav }, "", fullLangUrl);
    }

    // Update immediately to avoid flicker or lag in highlighting the active nav
    setActiveNav(nav);
    setSearchQuery("");

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Flattened tools list for search filtering
  const allTools = CATEGORIES_DATA.flatMap((c) =>
    c.tools.map((t) => ({ ...t, categoryTitle: c.title, categoryId: c.id })),
  );

  const searchResults = searchQuery.trim()
    ? allTools.filter(
        (t) =>
          t.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          t.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          t.categoryTitle.toLowerCase().includes(searchQuery.toLowerCase()),
      )
    : [];

  const favoriteToolsList = ALL_TOOLS_DATA.filter((t) => favorites.includes(t.id));

  const handleLaunchToolById = (toolInput: string | ToolItem) => {
    if (!toolInput) return;
    const toolId =
      typeof toolInput === "object" ? toolInput.id : String(toolInput);
    if (toolId === "pdf-merger" || toolId === "pdf-merge") {
      handleNavigate("pdf-merge");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }

    if (
      toolId === "pdf-rotator" ||
      toolId === "pdf-rotate" ||
      toolId === "rotate-pdf"
    ) {
      handleNavigate("pdf-rotator");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }

    if (
      toolId === "pdf-splitter" ||
      toolId === "pdf-split" ||
      toolId === "split-pdf"
    ) {
      handleNavigate("pdf-split");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-extractor" ||
      toolId === "pdf-extract" ||
      toolId === "extract-pdf"
    ) {
      handleNavigate("pdf-extractor");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (toolId === "pdf-page-number-adder") {
      handleNavigate("pdf-page-number-adder");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (toolId === "pdf-to-images" || toolId === "pdf-images" || toolId === "pdf-to-image" || toolId === "pdf-to-jpg" || toolId === "pdf-jpg" || toolId === "pdf-to-jpeg" || toolId === "pdf-jpeg") {
      handleNavigate("pdf-to-images");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "images-to-pdf" ||
      toolId === "image-to-pdf" ||
      toolId === "jpg-to-pdf" ||
      toolId === "png-to-pdf" ||
      toolId === "images-pdf"
    ) {
      handleNavigate("images-to-pdf");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-crop" ||
      toolId === "crop-pdf"
    ) {
      handleNavigate("pdf-crop");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-reorder-pages" ||
      toolId === "pdf-reorder" ||
      toolId === "reorder-pdf" ||
      toolId === "reorder-pages"
    ) {
      handleNavigate("pdf-reorder-pages");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-duplicate-page-finder" ||
      toolId === "pdf-duplicate" ||
      toolId === "duplicate-pdf" ||
      toolId === "duplicate-pages"
    ) {
      handleNavigate("pdf-duplicate-page-finder");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-page-remover" ||
      toolId === "pdf-remove" ||
      toolId === "remove-pdf" ||
      toolId === "remove-pages"
    ) {
      handleNavigate("pdf-page-remover");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-blank-page-remover" ||
      toolId === "pdf-blank-remover" ||
      toolId === "pdf-remove-blank-pages" ||
      toolId === "remove-blank-pages" ||
      toolId === "blank-page-remover"
    ) {
      handleNavigate("pdf-blank-page-remover");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-color-inverter" ||
      toolId === "color-inverter" ||
      toolId === "invert-pdf-colors" ||
      toolId === "pdf-color-invert"
    ) {
      handleNavigate("pdf-color-inverter");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-grayscale-converter" ||
      toolId === "pdf-grayscale" ||
      toolId === "convert-pdf-to-grayscale" ||
      toolId === "pdf-to-grayscale" ||
      toolId === "grayscale-pdf"
    ) {
      handleNavigate("pdf-grayscale-converter");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-watermark" ||
      toolId === "watermark-pdf" ||
      toolId === "pdf-watermarking" ||
      toolId === "watermark"
    ) {
      handleNavigate("pdf-watermark");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-bookmark-editor" ||
      toolId === "pdf-bookmark" ||
      toolId === "edit-pdf-bookmarks" ||
      toolId === "edit-bookmarks"
    ) {
      handleNavigate("pdf-bookmark-editor");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-bookmark-viewer" ||
      toolId === "pdf-bookmarks" ||
      toolId === "pdf-outline-viewer" ||
      toolId === "view-pdf-bookmarks"
    ) {
      handleNavigate("pdf-bookmark-viewer");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-signature-placeholder" ||
      toolId === "pdf-signature" ||
      toolId === "pdf-signatures" ||
      toolId === "signature-placeholder" ||
      toolId === "add-pdf-signature-placeholder"
    ) {
      handleNavigate("pdf-signature-placeholder");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-annotation-remover" ||
      toolId === "annotation-remover" ||
      toolId === "remove-pdf-annotations" ||
      toolId === "pdf-annotations-remover"
    ) {
      handleNavigate("pdf-annotation-remover");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (
      toolId === "pdf-margin-viewer" ||
      toolId === "pdf-margins" ||
      toolId === "pdf-margin" ||
      toolId === "pdf-margin-inspector" ||
      toolId === "margin-viewer"
    ) {
      handleNavigate("pdf-margin-viewer");
      if (activeQuickTool) setActiveQuickTool(null);
      return;
    }
    if (typeof toolInput === "object") {
      setActiveQuickTool(toolInput);
      return;
    }
    const foundInCategory = allTools.find((t) => t.id === toolId);
    if (foundInCategory) {
      setActiveQuickTool(foundInCategory);
      return;
    }
    const foundInExtended = ALL_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInExtended) {
      setActiveQuickTool(foundInExtended);
      return;
    }
    const foundInPdf = PDF_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInPdf) {
      setActiveQuickTool(foundInPdf);
      return;
    }
    const foundInImage = IMAGE_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInImage) {
      setActiveQuickTool(foundInImage);
      return;
    }
    const foundInText = TEXT_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInText) {
      setActiveQuickTool(foundInText);
      return;
    }
    const foundInDev = DEV_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInDev) {
      setActiveQuickTool(foundInDev);
      return;
    }
    const foundInColor = COLOR_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInColor) {
      setActiveQuickTool(foundInColor);
      return;
    }
    const foundInSecurity = SECURITY_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInSecurity) {
      setActiveQuickTool(foundInSecurity);
      return;
    }
    const foundInSocial = SOCIAL_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInSocial) {
      setActiveQuickTool(foundInSocial);
      return;
    }
    const foundInCalc = CALCULATOR_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInCalc) {
      setActiveQuickTool(foundInCalc);
      return;
    }
    const foundInFile = FILE_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInFile) {
      setActiveQuickTool(foundInFile);
      return;
    }
    const foundInMisc = MISC_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInMisc) {
      setActiveQuickTool(foundInMisc);
      return;
    }
    const foundInData = DATA_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInData) {
      setActiveQuickTool(foundInData);
      return;
    }
    const foundInProd = PRODUCTIVITY_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInProd) {
      setActiveQuickTool(foundInProd);
      return;
    }
    const foundInUnit = UNIT_CONVERSION_TOOLS_DATA.find((t) => t.id === toolId);
    if (foundInUnit) {
      setActiveQuickTool(foundInUnit);
      return;
    }
    // Fallback stub tool
    setActiveQuickTool({
      id: toolId,
      name: toolId.replace(/-/g, " ").toUpperCase(),
      description: "Interactive browser utility.",
      actionType: "generic",
    });
  };

  const isDark = theme === "dark";

  return (
    <div
      className={`min-h-screen flex flex-col font-sans theme-transition relative selection:bg-purple-500 selection:text-white ${
        isDark ? "bg-[#090b12] text-slate-100" : "bg-light-theme text-slate-900"
      }`}
    >
      {/* 10/10 SEO Meta & Schema Injector */}
      <SeoHead activeNav={activeNav} activeQuickTool={activeQuickTool} />

      {/* Background Dot Wave Pattern */}
      <BackgroundDots theme={theme} />

      {/* Navigation Header */}
      <Header
        theme={theme}
        onToggleTheme={toggleTheme}
        favoritesCount={favorites.length}
        onOpenFavorites={() => setFavoritesModalOpen(true)}
        activeNav={activeNav}
        setActiveNav={handleNavigate}
        onOpenInstallModal={() => setInstallAppModalOpen(true)}
      />

      {/* Main Page Content */}
      <main className="flex-1">
        <React.Suspense fallback={<div className="flex-1 flex items-center justify-center min-h-[50vh]"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div></div>}>
        {/* Render Page View according to activeNav */}
        {activeNav === "pdf-merge" || activeNav === "pdf-merger" ? (
          <PdfMergePage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-rotator" ||
          activeNav === "pdf-rotate" ||
          activeNav === "rotate-pdf" ? (
          <PdfRotatePage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-split" ||
          activeNav === "pdf-splitter" ||
          activeNav === "split-pdf" ? (
          <PdfSplitPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-extractor" ||
          activeNav === "pdf-extract" ||
          activeNav === "extract-pdf" ? (
          <PdfExtractPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-to-images" ||
          activeNav === "pdf-to-image" ||
          activeNav === "pdf-to-jpg" ||
          activeNav === "pdf-to-png" ? (
          <PdfToImagesPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "images-to-pdf" ? (
          <ImagesToPdfPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-page-number-adder" ||
          activeNav === "pdf-number-adder" ||
          activeNav === "pdf-page-number" ||
          activeNav === "add-numbers-to-pdf" ||
          activeNav === "add-page-numbers" ? (
          <PdfPageNumberAdderPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-crop" ||
          activeNav === "crop-pdf" ? (
          <PdfCropPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-reorder-pages" ||
          activeNav === "pdf-reorder" ||
          activeNav === "reorder-pdf" ||
          activeNav === "reorder-pages" ? (
          <PdfReorderPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-duplicate-page-finder" ||
          activeNav === "pdf-duplicate-finder" ||
          activeNav === "pdf-duplicate" ||
          activeNav === "duplicate-pdf" ||
          activeNav === "duplicate-pages" ||
          activeNav === "duplicate-finder" ||
          activeNav === "duplicate-page-finder" ? (
          <PdfDuplicateFinderPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-page-remover" ||
          activeNav === "remove-pdf" ||
          activeNav === "pdf-remove" ||
          activeNav === "remove-pages" ? (
          <PdfRemovePage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-blank-page-remover" ||
          activeNav === "pdf-blank-remover" ||
          activeNav === "pdf-remove-blank-pages" ||
          activeNav === "remove-blank-pages" ||
          activeNav === "blank-page-remover" ? (
          <PdfBlankPageRemoverPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-color-inverter" ||
          activeNav === "color-inverter" ||
          activeNav === "invert-pdf-colors" ||
          activeNav === "pdf-color-invert" ? (
          <PdfColorInverterPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-grayscale-converter" ||
          activeNav === "pdf-grayscale" ||
          activeNav === "convert-pdf-to-grayscale" ||
          activeNav === "pdf-to-grayscale" ? (
          <PdfGrayscaleConverterPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-watermark" ||
          activeNav === "watermark-pdf" ||
          activeNav === "watermark" ? (
          <PdfWatermarkPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-bookmark-editor" ? (
          <PdfBookmarkEditorPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-bookmark-viewer" ||
          activeNav === "pdf-bookmarks" ||
          activeNav === "pdf-outline-viewer" ? (
          <PdfBookmarkViewerPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-annotation-remover" ? (
          <PdfAnnotationRemoverPage
            theme={theme}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "pdf-margin-viewer" ||
          activeNav === "pdf-margins" ||
          activeNav === "pdf-margin" ||
          activeNav === "pdf-margin-inspector" ||
          activeNav === "pdf-safe-zone-viewer" ||
          activeNav === "margin-viewer" ? (
          <PdfMarginViewerPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-signature-placeholder" ||
          activeNav === "pdf-signature" ||
          activeNav === "pdf-sign" ||
          activeNav === "signature-placeholder" ? (
          <PdfSignaturePlaceholderPage
            theme={theme}
            onNavigate={handleNavigate}
            onOpenTool={handleLaunchToolById}
          />
        ) : activeNav === "pdf-tools" ? (
          <PdfToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "image-tools" || activeNav === "images" ? (
          <ImageToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "text-tools" || activeNav === "text" ? (
          <TextToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "developer-tools" ||
          activeNav === "dev-tools" ||
          activeNav === "developer" ? (
          <DeveloperToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "color-tools" ||
          activeNav === "colour-tools" ||
          activeNav === "color" ||
          activeNav === "colour" ? (
          <ColorToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "security-tools" || activeNav === "security" ? (
          <SecurityToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "social-tools" ||
          activeNav === "social-media-tools" ||
          activeNav === "social" ? (
          <SocialToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "calculator-tools" ||
          activeNav === "calculators" ||
          activeNav === "calculator" ||
          activeNav === "converter-tools" ? (
          <CalculatorToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "file-tools" ||
          activeNav === "files" ||
          activeNav === "file" ? (
          <FileToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "misc-tools" ||
          activeNav === "miscellaneous" ||
          activeNav === "misc" ? (
          <MiscToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "data-tools" ||
          activeNav === "data" ||
          activeNav === "data-converters" ? (
          <DataToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "productivity-tools" ||
          activeNav === "productivity" ||
          activeNav === "productivity-utilities" ? (
          <ProductivityToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "unit-conversion" ||
          activeNav === "unit-tools" ||
          activeNav === "converters" ||
          activeNav === "unit-converter" ? (
          <UnitConversionToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "time-date-tools" ||
          activeNav === "time-tools" ||
          activeNav === "time-and-date" ||
          activeNav === "time-date" ||
          activeNav === "clock-tools" ||
          activeNav === "date-tools" ? (
          <TimeDateToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "finance-tools" ||
          activeNav === "finance" ||
          activeNav === "financial-calculators" ||
          activeNav === "financial-tools" ||
          activeNav === "calculators-finance" ? (
          <FinanceToolsPage
            theme={theme}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "contact" ? (
          <ContactPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "merge-pdf-files-online" ||
          activeNav === "blog/merge-pdf-files-online" ||
          activeNav === "blog/how-to-merge-pdf-files" ||
          activeNav === "how-to-merge-pdf-files" ? (
          <BlogPostPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-extract-pdf-pages" || activeNav === "how-to-extract-pdf-pages" ? (
          <BlogExtractPdfPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-split-pdf-files" || activeNav === "how-to-split-pdf-files" ? (
          <BlogSplitPdfPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-rotate-pdf-pages" ||
          activeNav === "how-to-rotate-pdf-pages" ||
          activeNav === "rotate-pdf-online-free" ||
          activeNav === "blog/rotate-pdf-online-free" ||
          activeNav === "how-to-rotate-pdf" ||
          activeNav === "blog/how-to-rotate-pdf" ? (
          <BlogRotatePdfPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/remove-pages-from-pdf" ||
          activeNav === "remove-pages-from-pdf" ||
          activeNav === "blog/how-to-remove-pages-from-pdf" ||
          activeNav === "how-to-remove-pages-from-pdf" ||
          activeNav === "blog/pdf-page-remover" ||
          activeNav === "pdf-page-remover-guide" ? (
          <BlogRemovePdfPagesPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/reorder-pdf-pages" ||
          activeNav === "reorder-pdf-pages" ||
          activeNav === "blog/how-to-reorder-pdf-pages" ||
          activeNav === "how-to-reorder-pdf-pages" ||
          activeNav === "how-to-reorder-pdf" ||
          activeNav === "blog/how-to-reorder-pdf" ||
          activeNav === "blog/pdf-reorder" ||
          activeNav === "pdf-reorder-guide" ? (
          <BlogReorderPdfPagesPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-crop-pdf" ||
          activeNav === "how-to-crop-pdf" ||
          activeNav === "blog/crop-pdf" ||
          activeNav === "crop-pdf" ||
          activeNav === "how-to-crop-pdf-pages" ||
          activeNav === "blog/how-to-crop-pdf-pages" ||
          activeNav === "blog/pdf-crop" ||
          activeNav === "pdf-crop-guide" ? (
          <BlogCropPdfPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-find-duplicate-pages-in-pdf" ||
          activeNav === "how-to-find-duplicate-pages-in-pdf" ||
          activeNav === "blog/pdf-duplicate-finder" ||
          activeNav === "pdf-duplicate-finder-guide" ||
          activeNav === "how-to-find-duplicate-pages" ||
          activeNav === "blog/how-to-find-duplicate-pages" ||
          activeNav === "how-to-remove-duplicate-pages-from-pdf" ||
          activeNav === "blog/how-to-remove-duplicate-pages-from-pdf" ||
          activeNav === "blog/duplicate-pdf-finder" ||
          activeNav === "duplicate-pdf-finder" ? (
          <BlogDuplicateFinderPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-remove-blank-pages-from-pdf" ||
          activeNav === "how-to-remove-blank-pages-from-pdf" ||
          activeNav === "blog/how-to-remove-blank-pages" ||
          activeNav === "how-to-remove-blank-pages" ||
          activeNav === "blog/remove-blank-pages-from-pdf" ||
          activeNav === "remove-blank-pages-from-pdf" ||
          activeNav === "blog/remove-blank-pages" ||
          activeNav === "remove-blank-pages" ||
          activeNav === "blog/pdf-blank-page-remover" ||
          activeNav === "pdf-blank-page-remover-guide" ||
          activeNav === "blog/blank-page-remover" ? (
          <BlogBlankPageRemoverPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-add-page-numbers-to-pdf" ||
          activeNav === "how-to-add-page-numbers-to-pdf" ||
          activeNav === "blog/how-to-add-page-numbers" ||
          activeNav === "how-to-add-page-numbers" ||
          activeNav === "blog/add-page-numbers-to-pdf" ||
          activeNav === "add-page-numbers-to-pdf" ||
          activeNav === "blog/add-page-numbers" ||
          activeNav === "add-page-numbers" ||
          activeNav === "blog/pdf-number-adder" ||
          activeNav === "blog/pdf-page-number-adder" ||
          activeNav === "pdf-page-number-adder-guide" ||
          activeNav === "pdf-number-adder-guide" ? (
          <BlogPageNumberAdderPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-convert-pdf-to-images" ||
          activeNav === "how-to-convert-pdf-to-images" ||
          activeNav === "blog/how-to-convert-pdf-to-image" ||
          activeNav === "how-to-convert-pdf-to-image" ||
          activeNav === "blog/pdf-to-images" ||
          activeNav === "blog/pdf-to-image" ||
          activeNav === "pdf-to-images-guide" ||
          activeNav === "pdf-to-image-guide" ||
          activeNav === "blog/convert-pdf-to-images" ||
          activeNav === "convert-pdf-to-images" ? (
          <BlogPdfToImagesPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-convert-images-to-pdf" ||
          activeNav === "how-to-convert-images-to-pdf" ||
          activeNav === "blog/how-to-convert-image-to-pdf" ||
          activeNav === "how-to-convert-image-to-pdf" ||
          activeNav === "blog/images-to-pdf" ||
          activeNav === "blog/image-to-pdf" ||
          activeNav === "images-to-pdf-guide" ||
          activeNav === "image-to-pdf-guide" ||
          activeNav === "blog/convert-images-to-pdf" ||
          activeNav === "convert-images-to-pdf" ||
          activeNav === "how-to-convert-images-into-pdf" ||
          activeNav === "blog/how-to-convert-images-into-pdf" ? (
          <BlogImagesToPdfPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-convert-pdf-to-grayscale" ||
          activeNav === "how-to-convert-pdf-to-grayscale" ||
          activeNav === "blog/how-to-convert-pdf-to-black-and-white" ||
          activeNav === "how-to-convert-pdf-to-black-and-white" ||
          activeNav === "blog/pdf-grayscale" ||
          activeNav === "pdf-grayscale-guide" ||
          activeNav === "blog/pdf-to-grayscale" ||
          activeNav === "pdf-to-grayscale-guide" ||
          activeNav === "blog/convert-pdf-to-grayscale" ||
          activeNav === "convert-pdf-to-grayscale" ||
          activeNav === "blog/pdf-black-and-white" ||
          activeNav === "pdf-black-and-white-guide" ? (
          <BlogPdfGrayscalePage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-invert-pdf-colors" ||
          activeNav === "how-to-invert-pdf-colors" ||
          activeNav === "blog/how-to-invert-colors-in-pdf" ||
          activeNav === "how-to-invert-colors-in-pdf" ||
          activeNav === "blog/pdf-color-inverter" ||
          activeNav === "pdf-color-inverter-guide" ||
          activeNav === "blog/pdf-dark-mode" ||
          activeNav === "pdf-dark-mode-guide" ||
          activeNav === "blog/invert-pdf-colors" ||
          activeNav === "invert-pdf-colors" ||
          activeNav === "blog/how-to-turn-pdf-into-dark-mode" ||
          activeNav === "how-to-turn-pdf-into-dark-mode" ? (
          <BlogPdfColorInverterPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-add-watermark-to-pdf" ||
          activeNav === "how-to-add-watermark-to-pdf" ||
          activeNav === "blog/how-to-watermark-pdf" ||
          activeNav === "how-to-watermark-pdf" ||
          activeNav === "blog/pdf-watermark" ||
          activeNav === "pdf-watermark-guide" ||
          activeNav === "blog/add-watermark-to-pdf" ||
          activeNav === "add-watermark-to-pdf" ||
          activeNav === "blog/watermark-pdf" ||
          activeNav === "watermark-pdf" ? (
          <BlogPdfWatermarkPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-view-pdf-bookmarks" ||
          activeNav === "how-to-view-pdf-bookmarks" ||
          activeNav === "blog/how-to-inspect-pdf-bookmarks" ||
          activeNav === "how-to-inspect-pdf-bookmarks" ||
          activeNav === "blog/pdf-bookmark-viewer" ||
          activeNav === "pdf-bookmark-viewer-guide" ||
          activeNav === "blog/pdf-bookmarks" ||
          activeNav === "blog/view-pdf-bookmarks" ||
          activeNav === "view-pdf-bookmarks" ||
          activeNav === "blog/pdf-bookmark-guide" ? (
          <BlogPdfBookmarkViewerPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-edit-pdf-bookmarks" ||
          activeNav === "how-to-edit-pdf-bookmarks" ||
          activeNav === "blog/pdf-bookmark-editor" ||
          activeNav === "pdf-bookmark-editor-guide" ||
          activeNav === "blog/edit-pdf-bookmarks" ||
          activeNav === "edit-pdf-bookmarks" ? (
          <BlogPdfBookmarkEditorPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-sign-pdf" ||
          activeNav === "how-to-sign-pdf" ||
          activeNav === "blog/pdf-sign" ||
          activeNav === "pdf-sign-guide" ||
          activeNav === "blog/sign-pdf" ||
          activeNav === "sign-pdf" ? (
          <BlogPdfSignPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-remove-pdf-annotations" ||
          activeNav === "how-to-remove-pdf-annotations" ||
          activeNav === "blog/how-to-remove-annotations-from-pdf" ||
          activeNav === "how-to-remove-annotations-from-pdf" ||
          activeNav === "blog/pdf-annotation-remover" ||
          activeNav === "pdf-annotation-remover-guide" ||
          activeNav === "blog/remove-pdf-annotations" ||
          activeNav === "remove-pdf-annotations" ? (
          <BlogPdfAnnotationRemoverPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog/how-to-view-pdf-margins" ||
          activeNav === "how-to-view-pdf-margins" ||
          activeNav === "blog/how-to-measure-pdf-margins" ||
          activeNav === "how-to-measure-pdf-margins" ||
          activeNav === "blog/pdf-margin-viewer" ||
          activeNav === "pdf-margin-viewer-guide" ||
          activeNav === "blog/view-pdf-margins" ||
          activeNav === "view-pdf-margins" ||
          activeNav === "blog/measure-pdf-margins" ||
          activeNav === "measure-pdf-margins" ? (
          <BlogPdfMarginViewerPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "blog" ? (
          <BlogPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "about" ? (
          <AboutPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "privacy-policy" || activeNav === "privacy" ? (
          <PrivacyPolicyPage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "terms-of-service" || activeNav === "terms" ? (
          <TermsOfServicePage theme={theme} onNavigate={handleNavigate} />
        ) : activeNav === "categories" ? (
          <CategoriesPage
            theme={theme}
            onSelectCategory={(cat) => {
              if (cat.id === "pdf-tools") {
                handleNavigate("pdf-tools");
              } else if (cat.id === "image-tools") {
                handleNavigate("image-tools");
              } else if (cat.id === "text-tools") {
                handleNavigate("text-tools");
              } else if (
                cat.id === "developer-tools" ||
                cat.id === "dev-tools"
              ) {
                handleNavigate("developer-tools");
              } else if (
                cat.id === "color-tools" ||
                cat.id === "colour-tools"
              ) {
                handleNavigate("color-tools");
              } else if (cat.id === "security-tools" || cat.id === "security") {
                handleNavigate("security-tools");
              } else if (
                cat.id === "social-tools" ||
                cat.id === "social-media-tools" ||
                cat.id === "social"
              ) {
                handleNavigate("social-tools");
              } else if (
                cat.id === "calculator-tools" ||
                cat.id === "calculators" ||
                cat.id === "calculator"
              ) {
                handleNavigate("calculator-tools");
              } else if (
                cat.id === "file-tools" ||
                cat.id === "files" ||
                cat.id === "file"
              ) {
                handleNavigate("file-tools");
              } else if (
                cat.id === "misc-tools" ||
                cat.id === "miscellaneous" ||
                cat.id === "misc"
              ) {
                handleNavigate("misc-tools");
              } else if (
                cat.id === "data-tools" ||
                cat.id === "data" ||
                cat.id === "data-converters"
              ) {
                handleNavigate("data-tools");
              } else if (
                cat.id === "productivity-tools" ||
                cat.id === "productivity" ||
                cat.id === "productivity-utilities"
              ) {
                handleNavigate("productivity-tools");
              } else if (
                cat.id === "unit-conversion" ||
                cat.id === "converters" ||
                cat.id === "unit-tools" ||
                cat.id === "unit-converter"
              ) {
                handleNavigate("unit-conversion");
              } else if (
                cat.id === "time-date-tools" ||
                cat.id === "time-tools" ||
                cat.id === "time-and-date" ||
                cat.id === "time-date" ||
                cat.id === "clock-tools" ||
                cat.id === "date-tools"
              ) {
                handleNavigate("time-date-tools");
              } else if (
                cat.id === "finance-tools" ||
                cat.id === "finance" ||
                cat.id === "financial-calculators" ||
                cat.id === "financial-tools"
              ) {
                handleNavigate("finance-tools");
              } else {
                setSelectedCategory(cat);
              }
            }}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : activeNav === "all-tools" ||
          activeNav === "tools" ||
          activeNav === "popular-tools" ||
          activeNav === "new-tools" ? (
          <AllToolsPage
            theme={theme}
            favorites={favorites}
            onToggleFavorite={toggleFavorite}
            onOpenQuickTool={handleLaunchToolById}
            onNavigate={handleNavigate}
          />
        ) : (
          /* Default HOME LANDING PAGE */
          <>
            <Hero
              theme={theme}
              searchQuery={searchQuery}
              onSearchChange={setSearchQuery}
              onClearSearch={() => setSearchQuery("")}
            />

            {/* Live Search Results Overlay View if searching on Home */}
            {searchQuery.trim() !== "" ? (
              <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto z-10 relative">
                <div
                  className={`p-6 sm:p-8 rounded-2xl border ${
                    isDark
                      ? "bg-[#0f121e]/90 border-slate-800"
                      : "bg-white border-slate-200 shadow-md"
                  }`}
                >
                  <div className="flex items-center justify-between mb-6">
                    <div>
                      <h2 className="text-lg sm:text-3xl font-bold tracking-tight flex items-center gap-2">
                        <Search className="w-5 h-5 text-purple-500" />
                        <span>Search Results for "{searchQuery}"</span>
                      </h2>
                      <p
                        className={`text-xs mt-1 ${isDark ? "text-slate-400" : "text-slate-500"}`}
                      >
                        Found {searchResults.length} tools matching your search
                      </p>
                    </div>
                    <button
                      onClick={() => setSearchQuery("")}
                      className="text-xs px-3 py-1.5 rounded-lg bg-purple-600 text-white font-semibold hover:bg-purple-700"
                    >
                      Clear Search
                    </button>
                  </div>

                  {searchResults.length === 0 ? (
                    <div
                      className={`text-center py-12 text-sm ${isDark ? "text-slate-400" : "text-slate-500"}`}
                    >
                      No tools found for "{searchQuery}". Try searching for
                      "PDF", "Password", "JSON", "Image", or "Color".
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {searchResults.map((tool) => {
                        const isFav = favorites.includes(tool.id);
                        return (
                          <div
                            key={tool.id}
                            onClick={() => handleLaunchToolById(tool)}
                            className={`p-4 rounded-xl border transition-all duration-200 cursor-pointer flex flex-col justify-between ${
                              isDark
                                ? "bg-slate-900/80 border-slate-800 hover:border-purple-500/50 hover:bg-slate-800"
                                : "bg-slate-50 border-slate-200 hover:border-purple-300 hover:bg-purple-50/50"
                            }`}
                          >
                            <div>
                              <div className="flex items-center justify-between mb-1.5">
                                <span className="text-xs font-bold text-purple-500">
                                  {tool.categoryTitle}
                                </span>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleFavorite(tool.id);
                                  }}
                                  className="text-slate-400 hover:text-amber-400"
                                >
                                  <Star
                                    className={`w-4 h-4 ${isFav ? "fill-amber-400 text-amber-400" : ""}`}
                                  />
                                </button>
                              </div>
                              <h4 className="font-bold text-sm mb-1">
                                {tool.name}
                              </h4>
                              <p
                                className={`text-xs line-clamp-2 ${isDark ? "text-slate-400" : "text-slate-600"}`}
                              >
                                {tool.description}
                              </p>
                            </div>
                            <div className="mt-3 text-xs font-semibold text-purple-500 flex items-center justify-between">
                              <span>Open Tool</span>
                              <ArrowRight className="w-3.5 h-3.5" />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </section>
            ) : (
              /* Normal Home Landing Sections */
              <div id="categories-section">
                <CategoryGrid
                  categories={CATEGORIES_DATA}
                  theme={theme}
                  onSelectCategory={(cat) => {
                    if (cat.id === "pdf-tools") {
                      handleNavigate("pdf-tools");
                    } else if (cat.id === "image-tools") {
                      handleNavigate("image-tools");
                    } else if (cat.id === "text-tools") {
                      handleNavigate("text-tools");
                    } else if (
                      cat.id === "developer-tools" ||
                      cat.id === "dev-tools"
                    ) {
                      handleNavigate("developer-tools");
                    } else if (
                      cat.id === "color-tools" ||
                      cat.id === "colour-tools"
                    ) {
                      handleNavigate("color-tools");
                    } else if (
                      cat.id === "security-tools" ||
                      cat.id === "security"
                    ) {
                      handleNavigate("security-tools");
                    } else if (
                      cat.id === "social-tools" ||
                      cat.id === "social-media-tools" ||
                      cat.id === "social"
                    ) {
                      handleNavigate("social-tools");
                    } else if (
                      cat.id === "calculator-tools" ||
                      cat.id === "calculators" ||
                      cat.id === "calculator"
                    ) {
                      handleNavigate("calculator-tools");
                    } else if (
                      cat.id === "file-tools" ||
                      cat.id === "files" ||
                      cat.id === "file"
                    ) {
                      handleNavigate("file-tools");
                    } else if (
                      cat.id === "misc-tools" ||
                      cat.id === "miscellaneous" ||
                      cat.id === "misc"
                    ) {
                      handleNavigate("misc-tools");
                    } else if (
                      cat.id === "data-tools" ||
                      cat.id === "data" ||
                      cat.id === "data-converters"
                    ) {
                      handleNavigate("data-tools");
                    } else if (
                      cat.id === "productivity-tools" ||
                      cat.id === "productivity" ||
                      cat.id === "productivity-utilities"
                    ) {
                      handleNavigate("productivity-tools");
                    } else if (
                      cat.id === "unit-conversion" ||
                      cat.id === "converters" ||
                      cat.id === "unit-tools" ||
                      cat.id === "unit-converter"
                    ) {
                      handleNavigate("unit-conversion");
                    } else if (
                      cat.id === "time-date-tools" ||
                      cat.id === "time-tools" ||
                      cat.id === "time-and-date" ||
                      cat.id === "time-date" ||
                      cat.id === "clock-tools" ||
                      cat.id === "date-tools"
                    ) {
                      handleNavigate("time-date-tools");
                    } else if (
                      cat.id === "finance-tools" ||
                      cat.id === "finance" ||
                      cat.id === "financial-calculators" ||
                      cat.id === "financial-tools"
                    ) {
                      handleNavigate("finance-tools");
                    } else {
                      setSelectedCategory(cat);
                    }
                  }}
                />
              </div>
            )}

            {/* Stats Section Bar */}
            <div id="stats-section">
              <StatsSection stats={STATS_DATA} theme={theme} />
            </div>

            {/* Newsletter / Stay Updated Bar */}
            <NewsletterSection theme={theme} />
          </>
        )}
      </React.Suspense>
      </main>

      {/* Footer */}
      <Footer
        theme={theme}
        onSelectCategoryById={(catId) => {
          if (catId === "pdf-tools") {
            handleNavigate("pdf-tools");
            return;
          }
          if (catId === "image-tools") {
            handleNavigate("image-tools");
            return;
          }
          if (catId === "text-tools") {
            handleNavigate("text-tools");
            return;
          }
          if (catId === "developer-tools" || catId === "dev-tools") {
            handleNavigate("developer-tools");
            return;
          }
          if (catId === "color-tools" || catId === "colour-tools") {
            handleNavigate("color-tools");
            return;
          }
          if (catId === "security-tools" || catId === "security") {
            handleNavigate("security-tools");
            return;
          }
          if (
            catId === "social-tools" ||
            catId === "social-media-tools" ||
            catId === "social"
          ) {
            handleNavigate("social-tools");
            return;
          }
          if (
            catId === "calculator-tools" ||
            catId === "calculators" ||
            catId === "calculator"
          ) {
            handleNavigate("calculator-tools");
            return;
          }
          if (catId === "file-tools" || catId === "files" || catId === "file") {
            handleNavigate("file-tools");
            return;
          }
          if (
            catId === "misc-tools" ||
            catId === "miscellaneous" ||
            catId === "misc"
          ) {
            handleNavigate("misc-tools");
            return;
          }
          if (
            catId === "data-tools" ||
            catId === "data" ||
            catId === "data-converters"
          ) {
            handleNavigate("data-tools");
            return;
          }
          if (
            catId === "productivity-tools" ||
            catId === "productivity" ||
            catId === "productivity-utilities"
          ) {
            handleNavigate("productivity-tools");
            return;
          }
          if (
            catId === "unit-conversion" ||
            catId === "converters" ||
            catId === "unit-tools" ||
            catId === "unit-converter"
          ) {
            handleNavigate("unit-conversion");
            return;
          }
          if (
            catId === "time-date-tools" ||
            catId === "time-tools" ||
            catId === "time-and-date" ||
            catId === "time-date" ||
            catId === "clock-tools" ||
            catId === "date-tools"
          ) {
            handleNavigate("time-date-tools");
            return;
          }
          if (
            catId === "finance-tools" ||
            catId === "finance" ||
            catId === "financial-calculators" ||
            catId === "financial-tools"
          ) {
            handleNavigate("finance-tools");
            return;
          }
          const cat = CATEGORIES_DATA.find((c) => c.id === catId);
          if (cat) {
            setSelectedCategory(cat);
          } else {
            handleNavigate("categories");
          }
        }}
        onNavigate={handleNavigate}
      />

      {/* Modal 1: Category Details Modal */}
      {selectedCategory && (
        <CategoryModal
          category={selectedCategory}
          onClose={() => setSelectedCategory(null)}
          theme={theme}
          favorites={favorites}
          onToggleFavorite={toggleFavorite}
          onLaunchTool={(tool) => { setSelectedCategory(null); handleLaunchToolById(tool); }}
        />
      )}

      {/* Modal 2: Quick Interactive Tool Modal */}
      {activeQuickTool && (
        <QuickToolModal
          tool={activeQuickTool}
          onClose={() => setActiveQuickTool(null)}
          theme={theme}
        />
      )}

      {/* Modal 3: Favorites List Drawer/Modal */}
      {favoritesModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-md">
          <div
            className={`relative w-full max-w-lg rounded-2xl border p-6 shadow-2xl ${
              isDark
                ? "bg-[#0f121e] border-slate-800 text-white"
                : "bg-white border-slate-200 text-slate-900"
            }`}
          >
            <div className="flex items-center justify-between pb-4 border-b border-slate-800/50 mb-4">
              <div className="flex items-center gap-2">
                <Star className="w-5 h-5 text-amber-400 fill-amber-400" />
                <h3 className="font-bold text-lg">
                  My Favorite Tools ({favoriteToolsList.length})
                </h3>
              </div>
              <button
                onClick={() => setFavoritesModalOpen(false)}
                className={`p-1.5 rounded-lg ${isDark ? "hover:bg-slate-800" : "hover:bg-slate-100"}`}
              >
                ✕
              </button>
            </div>

            {favoriteToolsList.length === 0 ? (
              <p
                className={`text-center py-8 text-sm ${isDark ? "text-slate-400" : "text-slate-500"}`}
              >
                You haven't added any favorite tools yet. Click the star icon on
                any tool card to save it here!
              </p>
            ) : (
              <div className="space-y-2.5 max-h-80 overflow-y-auto">
                {favoriteToolsList.map((t) => (
                  <div
                    key={t.id}
                    onClick={() => {
                      setFavoritesModalOpen(false);
                      handleLaunchToolById(t);
                    }}
                    className={`p-3 rounded-xl border flex items-center justify-between cursor-pointer ${
                      isDark
                        ? "bg-slate-900/80 border-slate-800 hover:border-purple-500"
                        : "bg-slate-50 border-slate-200 hover:border-purple-400"
                    }`}
                  >
                    <div>
                      <div className="font-bold text-sm">{t.name}</div>
                      <div
                        className={`text-xs ${isDark ? "text-slate-400" : "text-slate-500"}`}
                      >
                        {t.description}
                      </div>
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(t.id);
                      }}
                      className="p-1 text-amber-400 hover:text-slate-400 ml-2"
                    >
                      <Star className="w-4 h-4 fill-amber-400" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal 5: PWA Install App Modal */}
      <InstallAppModal
        isOpen={installAppModalOpen}
        onClose={() => setInstallAppModalOpen(false)}
        isDark={isDark}
      />
    </div>
  );
}
